require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/entries.js
// module id = 500
// module chunks = 5 6 10 11 13 14 15 18 19 21 22 24 25 59